import React from "react";

import makeStyles from "@mui/styles/makeStyles";

import { styles } from "assets/jss/default/views/errorPageStyles.js";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import { useTrackPageView } from "hooks/useTrackPageView";

const useStyles = makeStyles(styles);

export default function InternalErrorPage() {
  useTrackPageView("Error");
  const classes = useStyles();
  return (
    <div className={classes.contentCenter}>
      <h2 className={classes.subTitle}>An error occurred</h2>
      <div className={classes.root}>
        <Typography className={classes.margin}>
          <Link className={classes.link} to="/" replace>
            Back to the home page
          </Link>
        </Typography>
      </div>
    </div>
  );
}
